<script setup>
import { computed, ref } from 'vue'

import '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/assets/styles/app.css'
import '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/assets/styles/sanitize.css'
import News from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/News.vue'
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

// dayjs
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

const topicsList = ref(['', '', ''])
topicsList.value = (await useFetch('/api/clothes/newslist'))?.data.value || []

const props = defineProps({
  appViewShow: {
    type: Boolean,
    default: true
  },
  isWebViewProp: {
    type: Boolean,
    default: false
  },
  listLength: {
    type: Number,
    default: 3
  },
  isWrap: {
    type: Boolean,
    default: false,
    required: false
  },
  ignoreTpid: {
    type: String,
    default: '',
    required: false
  }
})

const isWebViewFlag = ref(props.isWebViewProp)

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)

const filteredTopicsList = computed(() => {
  return topicsList.value
    .filter((item) => item.tpid !== props.ignoreTpid)
    .slice(0, props.listLength)
})
</script>

<template>
  <section
    v-if="(!isWebViewFlag || appViewShow) && topicsList.length > 0"
    class="newslist"
  >
    <SectionTitle
      title="服装に関するニュース"
      button-text="もっと読む"
      button-dir="left"
      button-col="white"
      button-link="/clothes/topics/"
    />
    <ul
      :data-wrap="isWrap"
      class="content"
    >
      <li
        v-for="content in filteredTopicsList"
        :key="content.id"
        :data-wrap="isWrap"
        class="list"
      >
        <News
          :img="content.image"
          :url="content.link"
          :title="content.title"
          :date="content.date"
        />
      </li>
    </ul>
  </section>
</template>

<style lang="scss" scoped>
.newslist {
  .content {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }
  .list {
    border-bottom: solid 1px #dfe4f0;
    &:first-child {
      border-top: solid 1px #dfe4f0;
    }
  }
}
main {
  .newslist {
    @media screen and (min-width: 830px) {
      .content {
        flex-direction: row;
        gap: 10px;
        &[data-wrap="true"] {
          flex-wrap: wrap;
        }
      }
      .list {
        flex: 1;
        border: solid 1px #dfe4f0;
        border-radius: 8px;
        overflow: hidden;
        &:is([data-wrap="true"] *) {
          flex: auto;
          width: calc((100% - 20px) / 3);
        }
      }
    }
  }
}
</style>
